import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserService } from '../../services/user.service';
import { BaseService } from '../../services/base.service';
import { NotificationService } from '../../services/notification.service';
import { MapService } from '../../services/map.service';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { reportsCategories } from '../../constants/Reports';
import { count } from 'rxjs/operator/count';
import { Observable } from 'rxjs/Observable';
import { SegmentEvents }from '../../constants/SegmentEvents';
import { SegmentService } from '../../services/segment.service';
import { Subscription } from 'rxjs/Subscription';
declare const google: any;

@Component({
  selector: 'app-demographic-report',
  templateUrl: './demographic-report.component.html',
  styleUrls: ['./demographic-report.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class DemographicReportComponent implements OnInit {
	mapLoadedSubscription: any;
	isIntegratedMapsActive: boolean = false;
	searchResults: any[];
	showLocationDropdown: boolean = false;
	focusedSearchItemIndex: any;
  reportCategories: any[] = reportsCategories.US_CATEGORIES;
  showReportCategories: boolean = false;
  demographicDistances: any[] = [];
  categorySearchValue: any;
  disableReportButton: boolean = false;
  inputChangeListener: Subject<any> = new Subject<any>();
  locationChangeListener: Subject<any> = new Subject<any>();
  reportSearchListener: Subject<any> = new Subject<any>();
  reverseGeocodedAddress: any;
  googleSearchedPlace: any;
  defaultReportObject: any = {
    name: 'Property Capsule Report',
    title: 'Property Capsule Report',
    report_request_data: {
      report_name: 'PROPERTY_CAPSULE_REPORT'
    }
  };
  polygonEditSubscription: Subscription;
  polygonDeleteSubscription: Subscription;
  closeDemoreportSubscription: Subscription;

  constructor(public userService: UserService, public baseService: BaseService,
    public mapService: MapService, public httpClient: HttpClient, public segmentService: SegmentService,
    public notificationService: NotificationService) {
  }

  ngOnInit() {
    let w = (<any>window);
    this.inputChangeListener
    .debounceTime(500)
    .distinctUntilChanged()
    .subscribe((data)=> {
      let element = <HTMLInputElement>document.getElementById('radius-input-'+data.index+''),
          inputValue = element.value ? (Math.round((parseFloat(element.value) + 0.00001) * 100) / 100) : 1,
          existingDemoOption = this.checkIfDemographicAlreadyExists(inputValue, this.demographicDistances[data.index].unit);
      if(this.demographicDistances[data.index].distance !== inputValue) {
        !this.demographicDistances[data.index].isDuplicate && this.deletePreviousDemographic(this.demographicDistances[data.index]);
        this.demographicDistances[data.index].distance = inputValue > 50 ? 50 : inputValue;
        if(!existingDemoOption) {
          this.addDemographics(this.demographicDistances[data.index]);
          this.demographicDistances[data.index].isDuplicate = false;
        } else {
          this.demographicDistances[data.index].isDuplicate = true;
        }
      }
      w.Events.publish('detectChanges');
    });

    this.locationChangeListener
    .debounceTime(500)
    .distinctUntilChanged()
      .subscribe(() => {
        let element = <HTMLInputElement>document.getElementById('demo-report-location-input'),
          inputValue = element.value;
        this.mapService.getLocationPredictions(inputValue, this.mapService.selectedDemoPointData).subscribe((response: any) => {
            this.searchResults = response;
          w.Events.publish('detectChanges');
        });
        w.Events.publish('detectChanges');
      });

    this.reportSearchListener
    .debounceTime(500)
    .distinctUntilChanged()
    .subscribe(() => {
      let element = <HTMLInputElement>document.getElementById('report-search'),
        inputValue = element && element.value ? element.value : '';
        this.categorySearchValue = inputValue;
        this.filterSearchCategory();
      w.Events.publish('detectChanges');
    });

    this.polygonEditSubscription = w.Events.subscribe('polygonEdited', (data) => {
      if(this.mapService.selectedDemoPointData.polygon && data && data.polygon &&
        (this.mapService.selectedDemoPointData.polygon.id === data.polygon.id)) {
        this.mapService.selectedDemoPointData = data;
        this.latLngToAddress();
      }
    });

    this.polygonDeleteSubscription = w.Events.subscribe('polygonDeleted', (polygonId) => {
      if(this.mapService.selectedDemoPointData.polygon && polygonId &&
        (this.mapService.selectedDemoPointData.polygon.id === polygonId)) {
        this.closeDeomgraphicsReport();
      }
    });

    this.closeDemoreportSubscription = w.Events.subscribe('closeDemographicReport', (data) => {
      if(data && data.lat !== this.mapService.selectedDemoPointData.lat && data.lng !== this.mapService.selectedDemoPointData.lng) {
        this.closeDeomgraphicsReport();
      }
    });

    !this.mapService.selectedDemoPointData.polygon && this.initializeDemographicArray();
    this.mapService.selectedDemoPointData.polygon && this.initializePolygonReport(this.mapService.selectedDemoPointData.polygon);
  }

  ngAfterViewInit() {
  	this.mapLoadedSubscription = this.baseService.mapLoadedChangeStream.subscribe((value)=>{
      if(value) {
      	this.isIntegratedMapsActive = (<any>window).mmap.isIntegratedMapsActive();
      }
      (<any>window).Events.publish('detectChanges');
    });
    this.latLngToAddress();
  }

  checkIfDemographicAlreadyExists(distance, unit) {
    let demoOption = this.demographicDistances.find((obj) => {
      return obj.distance === distance && obj.unit === unit;
    });
    return demoOption;
  }

  checkIfNumberHasDecimals(value) {
    if(value % 1 != 0) {
      return true;
    } else {
      return false;
    }
  }

  latLngToAddress() {
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': this.mapService.selectedDemoPointData }, (results, status) => {
      if (status === 'OK') {
        if (results[1]) {
          this.reverseGeocodedAddress = results[1].formatted_address;
        }
      } else {
        this.reverseGeocodedAddress = this.mapService.selectedDemoPointData.lat + ', ' + this.mapService.selectedDemoPointData.lng;
      }
      (<any>window).Events.publish('detectChanges');
    });
  }

  isFiltered(reportName) {
		if(/^\s*$/.test(this.categorySearchValue)) {
			return true;
		} else {
			if(new RegExp(this.categorySearchValue, 'i').test(reportName)) {
				return true;
			} else {
				return false;
			}
		}
  }

  filterSearchCategory() {
    for(let i = 0; i < this.reportCategories.length; i++) {
      if(this.reportCategories[i].value) {
        let count = 0;
        for(let j = 0; j < this.reportCategories[i].value.length; j++) {
          if(!this.isFiltered(this.reportCategories[i].value[j].title)) {
            count++
          }
        }
        this.reportCategories[i].hideCategory = (count === this.reportCategories[i].value.length) ? true : false;
        this.reportCategories[i].showSubCategory = (count === this.reportCategories[i].value.length) ? false : true;
      }
    }
  }

  initializeDemographicArray() {
    let demoPointObj = this.getDemographicPoint();
    if(demoPointObj) {
      this.setRingData(demoPointObj);
      this.setDrivetimeData(demoPointObj);
      this.initializeSpecialReport(demoPointObj);
    } else {
      this.closeDeomgraphicsReport();
    }
  }

  getDemographicPoint() {
    return (<any>window).demographicPoint.points.find((obj)=>{
      return obj.lat === this.mapService.selectedDemoPointData.lat &&
             obj.lng === this.mapService.selectedDemoPointData.lng;
    });
  }

  setRingData(demoPointObj) {
    let w = (<any>window);
    if(demoPointObj.rings) {
      for(let i = 0; i < demoPointObj.rings.length; i++) {
        this.demographicDistances.length < 4 && this.demographicDistances.push({
          distance: demoPointObj.rings[i].distance,
          unit: (demoPointObj.rings[i].responseData.unit === 'kilometer' ? 'kms' : 'miles'),
          lat: demoPointObj.lat,
          lng: demoPointObj.lng,
          ringColorPalleteIndex: demoPointObj.ringColorPalleteIndex,
          isRing: true,
          showUnitDropdown: false,
          type: 'ring',
          color: demoPointObj.rings[i].strokeColor,
        });
      }
    }
    w.Events.publish('detectChanges');
  }

  setDrivetimeData(demoPointObj) {
    let w = (<any>window);
    if(demoPointObj.driveTime) {
      for(let i = 0; i < demoPointObj.driveTime.length; i++) {
        this.demographicDistances.length < 4 && this.demographicDistances.push({
          distance: demoPointObj.driveTime[i].distance,
          unit: 'mins',
          lat: demoPointObj.lat,
          lng: demoPointObj.lng,
          driveTimeColorPalleteIndex: demoPointObj.driveTimeColorPalleteIndex,
          isDrivetime: true,
          showUnitDropdown: false,
          type: 'drivetime',
          color: demoPointObj.driveTime[i].strokeColor
        });
      }
    }
    w.Events.publish('detectChanges');
  }

  initializeSpecialReport(demoPointObj) {
    let demographics = demoPointObj.rings.length > 0 ? demoPointObj.rings[0] : demoPointObj.driveTime.length > 0 ? demoPointObj.driveTime[0] : null;
    if(demographics && demographics.countryCode === 'CA') {
      this.defaultReportObject = {
        name: 'DEPMarketProfile',
        title: 'Market Profile Canada',
        report_request_data: {
          report_name: 'DEP_MARKET_PROFILE_CANADA'
        }
      }
      this.reportCategories = reportsCategories.CA_CATEGORIES;
    }
  }

  initializePolygonReport(polygon) {
    if(polygon && polygon.countryCode && polygon.countryCode === 'CA') {
      this.defaultReportObject = {
        name: 'DEPMarketProfile',
        title: 'Market Profile Canada',
        report_request_data: {
          report_name: 'DEP_MARKET_PROFILE_CANADA'
        }
      }
      this.reportCategories = reportsCategories.CA_CATEGORIES;
    } else {
      this.defaultReportObject =  {
        name: 'business_summary',
        title: 'Business Summary',
        report_request_data: {
          report_name: 'BUSINESS_SUMMARY'
        }
      }
      this.reportCategories = this.reportCategories.filter((obj)=> {
        return obj.categoryName !== 'Property Capsule Report';
      });
    }
  }

  toggleActiveInputClass(toggle) {
  	let inputElement = document.getElementById('demo-report-location-input');
    if(this.mapService.selectedDemoPointData.polygon) {
      inputElement && inputElement.blur();
      this.notificationService.info('To edit location please edit the polygon on Map');
    } else {
      this.showLocationDropdown = toggle;
      this.addRemoveListeners(toggle);
      this.focusedSearchItemIndex = 0;
      if(toggle) {
        inputElement && inputElement.classList.add('active-input');
      } else {
        inputElement && inputElement.classList.remove('active-input');
      }
    }
    (<any>window).Events.publish('detectChanges');
  }

  addRemoveListeners(toggle) {
  	if(toggle) {
  		document.getElementById('demo-report-location-input').addEventListener('keydown', (event) => {
	      var keyCode = event.keyCode;
	      //Enter
	      if(keyCode === 13) {
          this.updateLocationInputFromDropdown(this.focusedSearchItemIndex);
	      }
	      //Up arrow
	      if(keyCode === 38) {
	      	this.goUpSearchPredictions();
	      }
	      //Down arrow
	      if(keyCode === 40) {
	      	this.goDownSearchPredictions();
	      }
	    });
  	} else {
  		document.getElementById('demo-report-location-input').addEventListener('keydown', ()=>{});
  	}
  }

  updateLocationInputFromDropdown(index) {
    this.reverseGeocodedAddress = this.searchResults[index].name;
    this.goToTheUpdatedPoint(this.searchResults[index]);
    this.deleteAllPointDemographics();
  }

  goToTheUpdatedPoint(address) {
    let w = <any>window;
    if ((address) && address.placeId && address.source === "GOOGLE") {
      // Create a Place instance and fetch details using the new API
      var place = new w.google.maps.places.Place({
        id: address.placeId
      });
      place.fetchFields({
        fields: ['displayName', 'formattedAddress', 'location', 'viewport', 'addressComponents']
      }).then((result) => {
        this.getPlacesResult()(result.place);
      }).catch((error) => {
        console.error('Error fetching place details:', error);
      });
    }
  }

  getPlacesResult() {
    let w = <any>window;
    return (placeResult) => {
      // Handle the new Places API response format
      // The Place object properties are directly accessible after fetchFields
      if (placeResult && placeResult.location) {
        this.googleSearchedPlace = {
          formatted_address: placeResult.formattedAddress || placeResult.displayName,
          geometry: {
            location: placeResult.location,
            viewport: placeResult.viewport
          },
          address_components: placeResult.addressComponents || []
        };
        w.autoComplete.onSuccess(this.googleSearchedPlace);
        let input = document.getElementById('demo-report-location-input');
        (<HTMLInputElement>input).value = placeResult.formattedAddress || placeResult.displayName;
        this.checkNewAddress(this.googleSearchedPlace.address_components);
        this.addAllPointRings();
      }
    }
  }

  checkNewAddress(address) {
    let category = this.reportCategories.find((obj) => {
      return obj.name && obj.name === 'Property Capsule Report';
    });
    if((address[address.length - 1].types[0] === 'country' && address[address.length - 1].short_name === 'CA') ||
       (address[address.length - 2].types[0] === 'country' && address[address.length - 2].short_name === 'CA'))  {
      this.defaultReportObject = {
        name: 'DEPMarketProfile',
        title: 'Market Profile Canada',
        report_request_data: {
          report_name: 'DEP_MARKET_PROFILE_CANADA'
        }
      }
      this.reportCategories = reportsCategories.CA_CATEGORIES;
      category.hideCategory = true;
    } else if((address[address.length - 1].types[0] === 'country' && address[address.length - 1].short_name === 'US') ||
       (address[address.length - 2].types[0] === 'country' && address[address.length - 2].short_name === 'US')) {
      this.defaultReportObject = {
        name: 'Property Capsule Report',
        title: 'Property Capsule Report',
        report_request_data: {
          report_name: 'PROPERTY_CAPSULE_REPORT'
        }
      };
      this.reportCategories = reportsCategories.US_CATEGORIES;
    } else {
      category.hideCategory = false;
    }
  }

  deleteAllPointDemographics() {
    for(let i = 0; i < this.demographicDistances.length; i++) {
      this.deletePreviousDemographic(this.demographicDistances[i]);
    }
  }

  addAllPointRings() {
    this.mapService.selectedDemoPointData.lat = this.googleSearchedPlace.geometry.location.lat();
    this.mapService.selectedDemoPointData.lng = this.googleSearchedPlace.geometry.location.lng();
    for(let i = 0; i < this.demographicDistances.length; i++) {
      this.demographicDistances[i].addDemographicMarker = (i === 0) ? true : false ;
      this.demographicDistances[i].lat = this.googleSearchedPlace.geometry.location.lat();
      this.demographicDistances[i].lng = this.googleSearchedPlace.geometry.location.lng();
      this.addDemographics(this.demographicDistances[i]);
    }
  }

  goUpSearchPredictions() {
    if(this.focusedSearchItemIndex === 0) {
      this.focusedSearchItemIndex = this.searchResults.length - 1;
    } else {
      this.focusedSearchItemIndex--;
    }
    let searchItems = document.getElementsByClassName('dropdown-contents');
    (<HTMLElement>searchItems[this.focusedSearchItemIndex ===  this.searchResults.length - 1? 0 : this.focusedSearchItemIndex + 1]).classList.remove('focused');
    this.changeFocusedSearchItemBackgroundColor(searchItems);
    this.adjustSearchResultScroll();
  }

  goDownSearchPredictions() {
    if(this.focusedSearchItemIndex === this.searchResults.length - 1) {
      this.focusedSearchItemIndex = 0;
    } else {
      this.focusedSearchItemIndex++;
    }
    let searchItems = document.getElementsByClassName('dropdown-contents');
    (<HTMLElement>searchItems[this.focusedSearchItemIndex ===  0 ? this.searchResults.length - 1 : this.focusedSearchItemIndex - 1]).classList.remove('focused');
    this.changeFocusedSearchItemBackgroundColor(searchItems);
    this.adjustSearchResultScroll();
  }

  changeFocusedSearchItemBackgroundColor(searchItems) {
    (<HTMLElement>searchItems[this.focusedSearchItemIndex]).classList.add('focused');
  }

  adjustSearchResultScroll() {
  	let scrollElement = document.getElementById('location-autocomplete-scroll').children[0],
  	    searchItemElementOffset = document.getElementById('search-item-'+this.focusedSearchItemIndex).offsetTop + 39,
  	    dropdownHeight = 200;
  	if(searchItemElementOffset > dropdownHeight) {
  		scrollElement.scrollTop = scrollElement.scrollTop - (searchItemElementOffset - dropdownHeight)
  	}
  }

  toggleSubCategory(index) {
    if(this.reportCategories[index].value) {
      this.reportCategories[index].showSubCategory =
      (this.reportCategories[index].showSubCategory ? !this.reportCategories[index].showSubCategory : true);
    } else {
      this.reportCategories[index].showSubCategory = false;
      this.defaultReportObject = this.reportCategories[index];
      this.toggleCategoryDropdown();
    }
    (<any>window).Events.publish('detectChanges');
  }

  selectOptionFromDropdown(categoryIndex, subCategoryIndex) {
    this.defaultReportObject = this.reportCategories[categoryIndex].value[subCategoryIndex];
    (<any>window).Events.publish('detectChanges');
  }

  toggleCategoryDropdown() {
    this.showReportCategories =  !this.showReportCategories;
    !this.showReportCategories && this.categorySearchValue && this.reportSearchListener.next({});
    (<any>window).Events.publish('detectChanges');
  }

  toggleUnitDropdown(index, toggle?) {
    this.demographicDistances[index].showUnitDropdown = !this.demographicDistances[index].showUnitDropdown;
    (<any>window).Events.publish('detectChanges');
  }

  hideUnitDropdown(index) {
    this.demographicDistances[index].showUnitDropdown = false;
    (<any>window).Events.publish('detectChanges');
  }

  changeRadiusValue(index, increment) {
    let element: any = <HTMLInputElement>document.getElementById('radius-input-'+index+''),
        value = parseFloat(element.value);
    if(increment) {
      value > 0 && value < 49 && (value += 1);
      element.value = value;
    } else {
      value > 1 && (value -= 1);
      element.value = value;
    }
    this.inputChangeListener.next({index: index});
    (<any>window).Events.publish('detectChanges');
  }

  addNewDemographics() {
    let lastDemoElement = this.demographicDistances[this.demographicDistances.length - 1],
    w = (<any>window),
    demoObject = {
      distance: lastDemoElement.distance < 45 ? lastDemoElement.distance + 5 : 50,
      unit: lastDemoElement.unit,
      lat: this.mapService.selectedDemoPointData.lat,
      lng: this.mapService.selectedDemoPointData.lng,
      showUnitDropdown: false,
      isRing: lastDemoElement.unit !== 'mins',
      isDrivetime: lastDemoElement.unit === 'mins',
      type: lastDemoElement.unit !== 'mins' ? 'ring' : 'drivetime',
      color: lastDemoElement.unit !== 'mins' ?
             w.branding.getDefaultRingColor({lat: this.mapService.selectedDemoPointData.lat, lng: this.mapService.selectedDemoPointData.lng})
             : w.branding.getDefaultDriveTimeColor(this.getDemographicPoint().driveTimeColorPalleteIndex)
    };
    this.demographicDistances.push(demoObject);
    this.addDemographics(demoObject);
    w.Events.publish('detectChanges');
  }

  addDemographics(demoObject) {
    let w = (<any>window);
    if(demoObject.isRing) {
      w.rings.add(demoObject);
    } else if(demoObject.isDrivetime) {
      w.driveTime.add(demoObject);
    }
  }

  deletePreviousDemographic(previousDemographic) {
    (<any>window).infoWindow.delete(previousDemographic.isDrivetime ? 'point-driveTime': 'point-rings', previousDemographic.lat+','+previousDemographic.lng, previousDemographic.distance);
  }

  deleteDemographicOption(index) {
    !this.demographicDistances[index].isDuplicate && this.deletePreviousDemographic(this.demographicDistances[index]);
    this.demographicDistances.splice(index, 1);
    this.demographicDistances.length === 0 && this.closeDeomgraphicsReport();
    (<any>window).Events.publish('detectChanges');
  }

  changeDemoUnit(index, unit) {
    let existingDemoOption = this.checkIfDemographicAlreadyExists(this.demographicDistances[index].distance, unit);
    !this.demographicDistances[index].isDuplicate && this.deletePreviousDemographic(this.demographicDistances[index]);
    this.demographicDistances[index].unit = unit;
    this.demographicDistances[index].isRing = (unit === 'miles') || (unit === 'kms');
    this.demographicDistances[index].isDrivetime = unit === 'mins';
    if(!existingDemoOption) {
      this.addDemographics(this.demographicDistances[index]);
      this.demographicDistances[index].isDuplicate = false;
    } else {
      this.demographicDistances[index].isDuplicate = true;
    }
    (<any>window).Events.publish('detectChanges');
  }

  closeDeomgraphicsReport() {
    this.mapService.showDemographicReport = false;
    (<any>window).Events.publish('detectChanges');
  }

  demographicReportApiCall() {
    let w = (<any>window),
    reportObject = {
      geom: this.mapService.selectedDemoPointData.polygon ? w.getPolygonGeoJson(this.mapService.selectedDemoPointData.polygon)
      : {
        type: 'Point',
        coordinates: [this.mapService.selectedDemoPointData.lng, this.mapService.selectedDemoPointData.lat]
      },
      category: (this.defaultReportObject.report_request_data.report_name).toUpperCase(),
      location: this.reverseGeocodedAddress,
      distances: this.mapService.selectedDemoPointData.polygon ? null : this.createDistancesApiObject()
    };
    this.disableReportButton = true;
    this.mapService.getDemographicReport(reportObject).subscribe((response: any)=>{
      if(response) {
        this.downloadGeneratedReport(response, reportObject);
        this.segmentService.log(SegmentEvents.demoreportDownloaded, {
          location: reportObject.location,
          report_type: reportObject.category,
          distances: reportObject.distances
        });
        this.disableReportButton = false;
        this.closeDeomgraphicsReport();
      }
    },(error)=>{
      this.disableReportButton = false;
      w.Events.publish('detectChanges');
      w.Events.publish('error', error);
    });
    w.Events.publish('detectChanges');
  }

  createDistancesApiObject() {
    let distances = [],
    distanceObjectLimit = (this.defaultReportObject.report_request_data.report_name === 'PROPERTY_CAPSULE_REPORT' && this.demographicDistances.length > 4) ?
                          4 : this.demographicDistances.length;
    for(let i = 0; i < distanceObjectLimit; i++) {
      distances.push({
        value: this.demographicDistances[i].distance,
        unit: (this.demographicDistances[i].unit).toUpperCase(),
        color: this.demographicDistances[i].color
      })
    }
    return distances;
  }

  downloadGeneratedReport(response, reportObject) {
    var w = (<any>window);
    let link = document.createElement('a');
    if(this.mapService.isUserAgentIos()) {
      if(response.url) {
        if(w.navigator.userAgent.indexOf('CriOS') >= 0) {
          w.open(response.url);
        }
        else {
          w.location.href = response.url;
        }
      }
    } else {
      var file = new Blob([response], {type: 'application/pdf'});
      var windowUrl = w.URL || w.webkitURL;
      var fileURL = windowUrl.createObjectURL(file);
      link.href = fileURL;
      link.download = reportObject.category + '_' + reportObject.location;
      document.body.appendChild(link);
      link.click();
      w.URL.revokeObjectURL(fileURL);
    }
  }

  ngOnDestroy() {
    let w = (<any>window);
    this.mapService.selectedDemoPointData = null;
    this.disableReportButton = false;
    this.polygonEditSubscription && this.polygonEditSubscription.unsubscribe();
    this.polygonDeleteSubscription && this.polygonDeleteSubscription.unsubscribe();
    this.closeDemoreportSubscription && this.closeDemoreportSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/demographic-report/demographic-report.component.ts